/**
 * Which navigation item is the current page: the most specific one whose
 * path the URL is in (/purchases/receipts is "Receipts inbox", not also
 * "Purchases"; /purchases/123 is still "Purchases").
 */

export function activeHrefFor(hrefs: string[], pathname: string): string | null {
  const within = (href: string) => pathname === href || pathname.startsWith(`${href}/`);
  return hrefs.filter(within).reduce<string | null>((best, href) => (best === null || href.length > best.length ? href : best), null);
}
